import { render, staticRenderFns } from "./NewAgreement.vue?vue&type=template&id=981f2bf6&scoped=true&"
import script from "./NewAgreement.vue?vue&type=script&lang=js&"
export * from "./NewAgreement.vue?vue&type=script&lang=js&"
import style0 from "./NewAgreement.vue?vue&type=style&index=0&id=981f2bf6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981f2bf6",
  null
  
)

export default component.exports